module.exports = function anonymous(data
/**/) {
var out=''; data.forEach(function(item) { out+='<label> <span class="block" style="background: '+( item.color )+'"></span> <span class="text">'+( item.text )+'</span></label>'; }); return out;
}